import { Component, OnInit, EventEmitter,Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { DatePickerGlobalOptions, stateOptionsSample, serviceConstants } from 'src/app/constants/service.constants';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { POLICY_HISTORY } from 'src/app/models/um/organization';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {
 @Input() public Content: any;
  constructor(
    public modalRef: NgbActiveModal,
    private adminService: AdministrationSummaryService,
    private modalService: NgbModal,
  ) {
  }

  content: any;
  history: POLICY_HISTORY[] = [];

  ngOnInit() {
    this.adminService.getRouteHistory('api/common/getroutes/' + this.Content.content.id).subscribe((result) => {
      this.history = result;
    });
  }
};


